var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 51,
    viewBox: "0 0 42 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3301 7.49262C34.3301 6.13275 33.4222 5.03027 32.3022 5.03027H9.69782C8.57784 5.03027 7.66992 6.13265 7.66992 7.49262V43.6071C7.66992 44.967 8.57784 46.0694 9.69782 46.0694H32.3023C33.4222 46.0694 34.3302 44.9671 34.3302 43.6071V7.49262H34.3301ZM33.0176 43.5553C33.0176 44.0086 32.715 44.376 32.3416 44.376H9.65836C9.28504 44.376 8.98242 44.0086 8.98242 43.5553V7.4448C8.98242 6.99158 9.28504 6.62412 9.65836 6.62412H32.3416C32.715 6.62412 33.0176 6.99158 33.0176 7.4448V43.5553Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2949 24.7529H11.0332V26.3467H31.2949V24.7529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2949 20.6689H11.0332V22.2627H31.2949V20.6689Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2949 28.8369H11.0332V30.4307H31.2949V28.8369Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2949 32.9209H11.0332V34.6143H31.2949V32.9209Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2949 37.0049H11.0332V38.6982H31.2949V37.0049Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5508 12.1623C13.1107 12.1623 13.5647 11.6111 13.5647 10.9311C13.5647 10.2512 13.1107 9.69995 12.5508 9.69995C11.9908 9.69995 11.5369 10.2512 11.5369 10.9311C11.5369 11.6111 11.9908 12.1623 12.5508 12.1623Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9305 12.1623C16.4904 12.1623 16.9444 11.6111 16.9444 10.9311C16.9444 10.2512 16.4904 9.69995 15.9305 9.69995C15.3705 9.69995 14.9166 10.2512 14.9166 10.9311C14.9166 11.6111 15.3705 12.1623 15.9305 12.1623Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.477 10.9311C31.477 11.6111 31.0229 12.1623 30.4632 12.1623C29.9034 12.1623 29.4493 11.6111 29.4493 10.9311C29.4493 10.2512 29.9034 9.69995 30.4632 9.69995C31.0229 9.69995 31.477 10.2512 31.477 10.9311Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0973 10.9311C28.0973 11.6111 27.6432 12.1623 27.0835 12.1623C26.5237 12.1623 26.0696 11.6111 26.0696 10.9311C26.0696 10.2512 26.5237 9.69995 27.0835 9.69995C27.6432 9.69995 28.0973 10.2512 28.0973 10.9311Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 51,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.3b0f6481e9dd8b66795b617e758de5a3.svg";
export { ForwardRef as ReactComponent };